import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { UserDataService } from '../../services/user-data/user-data.service';
import { MIN_STATUS } from '../../utils/constants';

@Injectable()
export class ResultAccessGuard {
  constructor(
    private _userDataService: UserDataService,
    private authService: AuthService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (environment.disableGuards) {
      return true;
    }

    if (
      parseInt(this.authService.getStatus().getValue(), 10) <
        MIN_STATUS.simulation_done &&
      !this._userDataService.getIsFromSimulate()
    ) {
      return false;
    }

    this._userDataService.setIsFromSimulate(false);
    this.authService.updateStatus(true);

    return true;
  }
}
